import { demoRequestHref, heroEntry } from '@/content/site';
import { onWhatsAppAnchorClick } from '@/lib/tracking';
import './StickyCta.css';

/** Único CTA de demo en landing mobile: fijo al pie; abre WhatsApp. */
export function MobileStickyCta() {
  return (
    <div className="sticky-cta sticky-cta--mobile-landing">
      <a
        href={demoRequestHref}
        className="btn btn-primary btn-block sticky-cta__btn"
        target="_blank"
        rel="noopener noreferrer"
        onClick={onWhatsAppAnchorClick('sticky_mobile_landing', heroEntry.ctaPrimary)}
      >
        {heroEntry.ctaPrimary}
      </a>
    </div>
  );
}
